import { Highlight, themes } from "prism-react-renderer";
import type React from "react";

interface HighlightedTextareaProps {
  code: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  language: "javascript" | "json";
  className?: string;
  textareaClassName?: string;
}

export const HighlightedTextarea: React.FC<HighlightedTextareaProps> = ({
  code,
  onChange,
  readOnly = false,
  language,
  className,
  textareaClassName,
}) => {
  return (
    <div className={className ?? "relative min-w-fit"}>
      {readOnly ? (
        <pre
          className="px-4 pb-4 m-0 pointer-events-none font-mono text-xs leading-relaxed whitespace-pre text-slate-300"
          style={{ background: "transparent" }}
        >
          {code}
        </pre>
      ) : (
        <Highlight theme={themes.nightOwl} code={code} language={language}>
          {({ className: highlightClass, style, tokens, getLineProps, getTokenProps }) => (
            <pre
              className={`${highlightClass} px-4 pb-4 m-0 pointer-events-none font-mono md:text-xs leading-relaxed whitespace-pre`}
              style={{ ...style, background: "transparent" }}
            >
              {tokens.map((line, lineIndex) => (
                <div
                  key={`line-${lineIndex}`}
                  {...getLineProps({ line })}
                  className="whitespace-pre"
                >
                  {line.map((token, tokenIndex) => (
                    <span key={`token-${lineIndex}-${tokenIndex}`} {...getTokenProps({ token })} />
                  ))}
                </div>
              ))}
            </pre>
          )}
        </Highlight>
      )}
      <textarea
        value={code}
        onChange={(e) => onChange(e.target.value)}
        readOnly={readOnly}
        className={
          textareaClassName ??
          "absolute inset-0 w-full h-full bg-transparent text-transparent caret-slate-300 px-4 pb-4 resize-none focus:outline-none font-mono text-xs leading-relaxed selection:bg-indigo-500/30 whitespace-pre"
        }
        spellCheck={false}
        style={{ caretColor: "#cbd5e1" }}
      />
    </div>
  );
};
